export default (props) => (
    <svg
        id="Layer_1"
        data-name="Layer 1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 135 135"
        width={props.size ?? 24}
        height={props.size ?? 24}
        fill="currentColor"
        stroke="none"
        stroke-width="10"
        stroke-linecap="round"
        stroke-linejoin="round"
        className={props.className}
    >
        <path
            d="M525 1195c-24-23-25-29-25-155V910H303c-221 0-242-6-283-72C1 807 0 787 0 485s1-322 20-353c11-18 34-41 52-52 32-19 52-20 568-20s536 1 568 20c18 11 41 34 52 52 19 31 20 51 20 353s-1 322-20 353c-40 66-64 72-267 72H810v120c0 125-11 171-45 184-9 3-61 6-116 6-93 0-102-2-124-25zm213-47c15-15 17-320 2-349-9-16-22-19-83-19-44 0-78 5-85 12-13 13-18 349-5 361 12 12 158 8 171-5zM500 813c1-73 36-93 160-93 88 0 93 1 121 29 21 22 29 39 29 65v36h352l29-29 29-29V178l-29-29-29-29H118l-29 29-29 29v614l29 29 29 29h382v-37z"
            transform="matrix(.1 0 0 -.1 0 128)"
        ></path>
        <path
            d="M606 1029c-33-26-36-79-6-109s83-27 109 6c28 35 26 69-4 99s-64 32-99 4zM303 690c-59-35-79-110-47-172 15-28 14-31-5-45-38-26-62-88-59-151l3-57 164-3c112-2 168 1 177 9 32 26 9 133-40 187-32 35-33 38-18 60 8 12 15 39 15 60 0 103-104 165-190 112zm117-255c37-19 60-52 60-87v-28H365c-127 0-130 1-100 64 28 59 96 82 155 51zM654 475c-4-8-4-22 0-30 5-13 37-15 233-13l228 3v50l-228 3c-196 2-228 0-233-13zM663 383c-18-7-16-50 3-57 20-8 238-8 258 0 21 8 21 50 0 58-19 7-243 7-261-1z"
            transform="matrix(.1 0 0 -.1 0 128)"
        ></path>
    </svg>
);
